"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingClassSchema = exports.BILLING_CLASSES = void 0;
exports.isBillableClass = isBillableClass;
const zod_1 = require("zod");
exports.BILLING_CLASSES = ['standard', 'internal', 'pilot', 'design_partner'];
exports.BillingClassSchema = zod_1.z.enum(exports.BILLING_CLASSES);
function isBillableClass(billingClass) {
    return billingClass === 'standard';
}
//# sourceMappingURL=billing-class.js.map